///
/// EarthBrowser
///
/// Migration v14 to v15: Add Python Terminal command history persistence
///
/// Created by Matt Giger on December 22, 2025
/// Copyright (c) 2025 Geodata Labs
///

interface StateV14 {
	userInterface?: Record<string, unknown>
}

/**
 * Migration from version 14 to 15: Add persistent Python command history
 * - Adds pythonCommandHistory field to userInterface slice (empty array)
 * - Python command history is stored for persistence across launches
 * - Stores up to 100 most recent Python commands
 */
export function migrateV14toV15(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV14

	// Return new state with pythonCommandHistory added
	return {
		...s,
		userInterface: {
			...s.userInterface,
			pythonCommandHistory: []
		}
	}
}
